/* eslint-disable webflow/no-delete */

import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;

  const needsConversion =
    data.hasOwnProperty('dropdown') &&
    data.dropdown.type === 'wrapper' &&
    (data.dropdown.hasOwnProperty('hover') ||
      data.dropdown.hasOwnProperty('delay'));

  return {
    needed: needsConversion,
    logData: {
      msg: 'Dropdown data should be converted to Data Type',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      if (data.attr && typeof data.attr['data-hover'] !== 'boolean') {
        data.attr['data-hover'] =
          data.attr['data-hover'] === '1' || data.attr['data-hover'] === 'true';
      }

      if (
        data.temp &&
        data.temp.dropdown &&
        data.temp.dropdown.hasOwnProperty('isOpen')
      ) {
        data.temp.dropdown.menu = data.temp.dropdown.isOpen ? 'show' : 'hide';
        delete data.temp.dropdown.isOpen;
      }
      if (data.dropdown) {
        delete data.dropdown.hover;
        delete data.dropdown.delay;
      }
    },
  };
};
